import { render, staticRenderFns } from "./BuildingEditLayoutSettingsTab.vue?vue&type=template&id=f7672b20"
import script from "./BuildingEditLayoutSettingsTab.vue?vue&type=script&lang=ts"
export * from "./BuildingEditLayoutSettingsTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports